// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__TcOwW","form":"styles_form__px6Su"};